export default "__VITE_ASSET__Cx29ua70__"